import {
  Box,
  Grid,
  Paper,
  Button,
  TextField,
  MenuItem,
  CircularProgress
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import {
  getAdminIssuerLogsAction,
  getAdminLogsAction,
  getSelf
} from 'src/store/actions/LogActions';
import moment from 'moment';
import { getStaff } from 'src/store/actions/StaffActions';
import { getLastNDays } from 'src/utils/utils';
import { getClientsStaffAction } from 'src/store/actions/ClientManagerActions';
import useProfile from 'src/hooks/useProfile';

function LogsFilter({ type, handleFilter }) {
  const dispatch = useDispatch();
  // const profile = JSON.parse(sessionStorage.getItem('profile'));
  const { isAdmin, profile } = useProfile();
  const staffData = useSelector((state) => state.Staff.staffData);
  const clients = useSelector((state) => state.Clients.clients);
  const clientsStaff = useSelector((state) => state.Clients.clientsStaff);
  const [formValues, setFormValues] = React.useState({
    values: { fromDate: getLastNDays(30), toDate: getLastNDays(0) }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getStaff(profile));
    dispatch(getClientsStaffAction({}, isAdmin));
  }, [profile, isAdmin]);

  const handleChange = (event) => {
    event.persist();
    setFormValues((formVals) => ({
      ...formVals,
      values: {
        ...formVals.values,
        [event.target.name]: event.target.value
      }
    }));
  };

  // const handleSubmit = () => {
  //   handleFilter(formValues.values, type);
  // };

  const handleSubmit = async () => {
    setLoading(true);
    const obj = {
      issuerStaffID: formValues.values.issuerStaffID || '-',
      adminID: formValues.values.adminID || '-',
      issuerID: formValues.values.issuerID || '-',
      from: moment(formValues.values.fromDate).unix() || '-',
      to: moment(formValues.values.toDate).unix() || '-'
    };
    switch (type) {
      case 'self':
        await dispatch(getSelf(obj, profile));
        setLoading(false);
        break;
      case 'admin':
        await dispatch(getAdminLogsAction(obj, profile));
        setLoading(false);
        break;
      case 'issuer':
        await dispatch(getAdminIssuerLogsAction(obj, profile));
        setLoading(false);
        break;
      default:
        break;
    }
  };
  return (
    // <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <Paper>
      <Grid
        container
        spacing={2}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          paddingLeft: 10,
          paddingRight: 10
        }}
      >
        {type == 'admin' && profile.super == 1 && (
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              select
              margin="normal"
              name="adminID"
              label="Admin"
              required
              variant="outlined"
              size="small"
              onChange={handleChange}
              value={formValues.values.adminID || ''}
            >
              <MenuItem value="">Select Admin</MenuItem>
              {staffData.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.fullname}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        )}

        {type == 'admin' && profile?.super == '0' && (
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              select
              margin="normal"
              name="issuerStaffID"
              label="Client Staff"
              required
              variant="outlined"
              size="small"
              onChange={handleChange}
              value={formValues.values.issuerStaffID || ''}
            >
              <MenuItem value="">Select Client Staff</MenuItem>
              {clientsStaff.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.fullname}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        )}

        {type == 'issuer' && (
          <>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                select
                margin="normal"
                name="issuerID"
                label="Client"
                required
                variant="outlined"
                size="small"
                onChange={handleChange}
                value={formValues.values.issuerID || ''}
              >
                <MenuItem value="">Select Client</MenuItem>
                {clients.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    {item.fullname}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                select
                margin="normal"
                name="issuerStaffID"
                label="Client Staff"
                required
                variant="outlined"
                size="small"
                onChange={handleChange}
                value={formValues.values.issuerStaffID || ''}
              >
                <MenuItem value="">Select Client Staff</MenuItem>
                {clientsStaff.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    {item.fullname}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </>
        )}
        <Grid item xs={12} md={3}>
          <TextField
            id="date"
            label="From Date"
            type="date"
            fullWidth
            name="fromDate"
            defaultValue="2017-05-24"
            onChange={handleChange}
            value={formValues.values.fromDate || ''}
            InputLabelProps={{
              shrink: true
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="todate"
            label="To Date"
            type="date"
            name="toDate"
            fullWidth
            defaultValue="2017-05-24"
            onChange={handleChange}
            value={formValues.values.toDate || ''}
            InputLabelProps={{
              shrink: true
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            disabled={loading}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            {loading && <CircularProgress size="1.5rem" />}
            Filter
          </Button>
        </Grid>
      </Grid>
    </Paper>
    // </MuiPickersUtilsProvider>
  );
}

export default LogsFilter;
